import { useEffect, useState } from "react";
import { Badge } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { buscarConversasWhatsapp } from "../../services/whatsappConversationService";

export default function AtendimentoCard() {
  const [pending, setPending] = useState(0);

  useEffect(() => {
    let active = true;
    let isRefreshing = false;

    const refreshPending = async () => {
      if (document.visibilityState !== "visible" || isRefreshing) return;

      isRefreshing = true;
      try {
        const items = await buscarConversasWhatsapp();
        if (active) {
          setPending(items.filter((conversation) => conversation.lastDirection === "inbound").length);
        }
      } catch (error) {
        console.error(error);
      } finally {
        isRefreshing = false;
      }
    };

    void refreshPending();
    const intervalId = window.setInterval(refreshPending, 30_000);
    document.addEventListener("visibilitychange", refreshPending);

    return () => {
      active = false;
      window.clearInterval(intervalId);
      document.removeEventListener("visibilitychange", refreshPending);
    };
  }, []);

  return (
    <div className="card" style={{ position: "relative", textAlign: "left" }}>
      <Badge
        count={pending}
        showZero={false}
        overflowCount={99}
        style={{ position: "absolute", top: 18, right: 18, backgroundColor: "#cf1322" }}
      />
      <div style={{ textAlign: "center" }}>
        <MessageOutlined style={{ fontSize: "2rem", marginBottom: "1rem", color: "#003644" }} />
      </div>
      <h2 style={{ textAlign: "center" }}>Atendimento</h2>
      <a href="/atendimento">Ver atendimentos</a>
    </div>
  );
}
